import styled from 'vue3-styled-components'

const StyledResetPassword = styled.section``

export default StyledResetPassword
